import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  PreloadAllModules,
  provideRouter,
  RouteReuseStrategy,
  withPreloading,
  withRouterConfig
} from '@angular/router';

import { routes } from './app.routes';
import { IonicRouteStrategy, provideIonicAngular } from "@ionic/angular/standalone";
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule
} from "@ngx-translate/core";
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AuthInterceptor } from "@core/interceptors/auth.interceptor";
import { RefreshTokenInterceptor } from "@core/interceptors/refresh-token.interceptor";
import { BASE_PATH } from "@api/api";
import { environment } from "@env/environment";
import { DebugHttpInterceptor } from "@core/interceptors/debug-http.interceptor";
import { ErrorHandlerInterceptor } from "@core/interceptors/error-handler.interceptor";

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    return params.key;
  }
}


export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BrowserModule,
      ReactiveFormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: CustomMissingTranslationHandler,
        },
        isolate: true
      })
    ),
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    provideIonicAngular({mode: 'md', innerHTMLTemplatesEnabled: true}),
    provideRouter(routes, withPreloading(PreloadAllModules), withRouterConfig({onSameUrlNavigation: 'reload'})),
    provideHttpClient(withInterceptors([
      DebugHttpInterceptor,
      RefreshTokenInterceptor,
      AuthInterceptor,
      ErrorHandlerInterceptor,
      // AppVersionInterceptor,
    ])),
    provideAnimations(),
    provideAnimationsAsync(),
    {provide: BASE_PATH, useValue: environment.apiBaseUrl},
  ]
};
